import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { AiFillHome } from 'react-icons/ai';
import { FaUserGraduate } from 'react-icons/fa';
import { AiFillMedicineBox } from 'react-icons/ai';
import { FaBlog } from 'react-icons/fa';
import { AiFillContacts } from 'react-icons/ai';
import { AiFillDashboard } from 'react-icons/ai';
import './Header.css';

const MobileMenu = () => {
   useEffect(() => {
    
    const list = document.querySelectorAll(".list");

    function activeLink() {
      list.forEach((item) => item.classList.remove("active"));
      this.classList.add("active");
    }
    list.forEach((item) => item.addEventListener("click", activeLink));
   }, []);
    
  
    return (
        <div class="navigation">
        <ul>
          <li class="list active">
            <Link to='/'>
              <span class="icon">
              <AiFillHome className='text-white text-xl'/>
              </span>
              <span class="text">Home</span>
            </Link>
          </li>
          <li class="list">
            <Link to='about'>
              <span class="icon">
              <FaUserGraduate className='text-white text-xl'/>
              </span>
              <span class="text">About</span>
            </Link>
          </li>
          <li class="list">
            <Link to='portfolio'>
              <span class="icon">
              <AiFillMedicineBox  className='text-white text-xl'/>
              </span>
              <span class="text">Portfolio</span>
            </Link>
          </li>
          <li class="list">
            <Link to='blog'>
              <span class="icon">
              <FaBlog  className='text-white text-xl'/>
              </span>
              <span class="text">Blog</span>
            </Link>
          </li>
          <li class="list">
            <Link to='contact'>
              <span class="icon">
              <AiFillContacts className='text-white text-xl'/>
              </span>
              <span class="text">Contact</span>
            </Link>
          </li>
          <li class="list">
            <Link to='dashboard'>
              <span class="icon">
              <AiFillDashboard className='text-white text-xl'/>
              </span>
              <span class="text">Dashboard</span>
            </Link>
          </li>
          <div class="indicator"></div>
        </ul>
      </div>
  
    );
  };
  

export default MobileMenu;
